import Avatar from "./avatar";
import classes from "../classes";
import { hasPayout } from "../payouts";
import pure from "./higher-order/pure";
import React from "react";
import { ordinal } from "../ordinal";

export default pure(function TvLeaderboardBasic({ tickets, tournament, users }) {
  var maxColumnSize = 5;
  var columnSize = Math.min(maxColumnSize, tickets.size);
  return (
    <div className="batch-g">
      <div className="batch-c-1-1 batch-c-md-1-1">
        {tickets.take(columnSize).map((t) => <TvLeaderboardBasicItem key={t.get("id")} ticket={t} tournament={tournament} users={users} />)}
      </div>
    </div>
  );
});

var TvLeaderboardBasicItem = pure(function TvLeaderboardBasicItem({ ticket, tournament, users }) {
  var user = users.get(ticket.get("user_id"));
  var username = "---";
  var winner = hasPayout(ticket);

  if (user !== undefined) {
    username = user.get("username");
  }

  var score = ticket.get("score");
  if (tournament.get("tournament_type") === "Survivor") {
    score = Math.floor(score);
    if (score === 1) {
      score += " Win";
    } else {
      score += " Wins";
    }
  }

  return (
    <div className={classes({
      "leaderboard-grid_item": true,
      "leaderboard-grid_item--is-winner": winner
    })}>
      <table className="leaderboard-grid_table">
        <tbody>
          <tr>
            <td className="leaderboard-grid_cell leaderboard-grid_cell--rank">
              <h1 className="leaderboard-grid_rank">
                {ordinal(ticket.get("rank"))}
              </h1>
            </td>

            <td className="leaderboard-grid_cell leaderboard-grid_cell--avatar">
              <Avatar small user={user} />
            </td>

            <td className="leaderboard-grid_cell leaderboard-grid_cell--username">
              <h2 className="leaderboard-grid_username">
                <span>
                  {username}
                </span>
              </h2>
            </td>

            <td className="leaderboard-grid_cell leaderboard-grid_cell--score">
              <div className="leaderboard-grid_score">
                {score}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});
